import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import './PlayButtons.css';

interface Props {
  label: string;
  /** Font Awesome icon rendered before the label (10px gap), as in the prototype */
  icon?: IconDefinition;
  onClick?: () => void;
  type?: 'button' | 'submit';
  disabled?: boolean;
  loading?: boolean;
  className?: string;
  testId?: string;
}

/**
 * The one primary CTA style for Play (design review round 1, item 2): the
 * branding gradient, 56px tall, 12px radius, 16px/700 text. Every primary
 * action in Play renders through this component so the style stays in one
 * place.
 */
export const PlayPrimaryButton: React.FC<Props> = ({ label, icon, onClick, type = 'button', disabled, loading, className, testId }) => (
  <button
    type={type}
    className={`play-primary-button ${className ?? ''}`}
    onClick={onClick}
    disabled={disabled || loading}
    aria-busy={loading || undefined}
    data-testid={testId}
  >
    {loading ? <span className="play-primary-button__spinner" aria-hidden="true" /> : icon ? <FontAwesomeIcon icon={icon} /> : null}
    <span>{label}</span>
  </button>
);

export default PlayPrimaryButton;
